export enum FoxColor {
  baseBlack = '#111213',
  baseWhite = '#FFFFFF',

  grey900 = '#111213',
  grey800 = '#1d1e20',
  grey700 = '#2f3237',
  grey600 = '#5e636e',
  grey500 = '#8f96a3',
  grey400 = '#c2c9d6',
  grey300 = '#dee3ed',
  grey200 = '#f1f3f9',
  grey100 = '#f3f5f9',

  blue1000 = '#003dcc',
  blue800 = '#004EFF',
  blue600 = '#4880FF',
  blue400 = '#B9CEFF',
  blue200 = '#DBE4FD',
  blue150 = '#F0F2FB',
  blue100 = '#F5F6FA',
  blue50 = '#FBFCFF',

  green800 = '#269723',
  green600 = '#3ACC5A',
  green400 = '#7bdd90',
  green200 = '#BCEEC5',

  red800 = '#D3003A',
  red600 = '#FF0046',
  red400 = '#FF4D73',
  red200 = '#F1BDC6',

  orangy800 = '#FF902D',
  orangy600 = '#FFBD04',
  orangy400 = '#FFDC75',
  orangy200 = '#FFF2C1',

  teal800 = '#00a699',
  teal600 = '#00e0ce',
  teal400 = '#5aeddc',
  teal200 = '#a3f5eb',

  violet1000 = '#6c3fcf',
  violet800 = '#7c40ff',
  violet600 = '#8e5eff',
  violet400 = '#bb14ff',
  violet200 = '#e5dcff',

  cyan1000 = '#007C91',
  cyan800 = '#0092AC',
  cyan600 = '#00A8C6',
  cyan400 = '#5FD4ED',
  cyan200 = '#CCF1FA',
}

export const setFoxColors = () => {
  for (const [key, value] of Object.entries(FoxColor)) {
    document.documentElement.style.setProperty(`--${key}`, `${value}`)
  }
}
